export default __webpack_public_path__ + "static/media/infraIcon.784bff1a.png";